module.exports = __webpack_public_path__ + "static/media/start2impact.3ef9bf7c.png";